module.exports = __webpack_public_path__ + "img/Anhänger_0_5t.37a274f2.svg";